__turbopack_context__.v({
  "LabeledCertificationTexts": "CertificationDisplay-module-scss-module__Y8c5Bq__LabeledCertificationTexts",
  "compactCertification": "CertificationDisplay-module-scss-module__Y8c5Bq__compactCertification",
  "mobile": "CertificationDisplay-module-scss-module__Y8c5Bq__mobile",
});
